import axios from "axios"
import baseURL from "../configs/api"

export const post_EarlyReturn = (data: any, userId: number, tenantId: string) => {
    return axios({
        url: `${baseURL}earlyReturn?userId=${userId}`,
        method: "POST",
        headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
        },
        withCredentials: true,
        data: data
    }).then(response => response.data);
}

export const put_EarlyReturn = (data: any, userId: number, tenantId: string) => {
    return axios({
        url: `${baseURL}earlyReturn?userId=${userId}`,
        method: "PUT",
        headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
        },
        withCredentials: true,
        data: data
    }).then(response => response.data);
}


export const getEarlyReturnByReservationId = (primaryKey: number, tenantId: string) => {
    return getFetch(`earlyReturn/GetEarlyReturnsByReservationId/${primaryKey}`, tenantId);
}

const getFetch = (url: string, tenantId: string, params = {}) => {
    return axios({
        url: baseURL + url,
        method: "GET",
        headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
        },
        params: params
    }).then(response => response.data);
}